import {Injectable} from '@angular/core';
import {SwitchBoard} from './SwitchBoard';

@Injectable({
  providedIn: 'root'
})
export class PageTitleService{

    team: any;
    title: any;
    unreadCount: any;
    selectedCompanyId: any;

    constructor(private switchBoard: SwitchBoard){
    }

    setPageTitle(text) {
        this.title = text;
        this.switchBoard.onPageChange.next(text);
    }

    setTeamObj(obj){
        this.team = obj;
    }

    getTeamObj(){
        return this.team;
    }

    clearTeam() {
        this.team = {};
    }

    getPageTitle() {
        return this.title;
    }

    setUnreadCount(count) {
        this.unreadCount = count;
    }

    getUnreadCount() {
        return this.unreadCount;
    }

    resetUnreadCount() {
        this.unreadCount = 0;
    }

    setSelectedCompany(id){
        this.selectedCompanyId = id;
    }

    getSelectedCompany(){
        return this.selectedCompanyId;
    }

    resetSelectedCompany(){
        this.selectedCompanyId = null;
    }

}
